import './Pulsar.css';
import { DiscussionEmbed } from 'disqus-react';

function Articles ({contenido, id, titulo}){

        return(
              
          <>
                  
        <section className="articulos">

          {contenido}

            <hr style={{ margin: '50px 0', border: '1px solid #333' }} />

            <DiscussionEmbed
          shortname="pulsar-la-tecla"
          config={{
            url: `https://pulsarlatecla.es${window.location.pathname}`,
            identifier: window.location.pathname, 
            title: titulo,  
            language: 'es_ES'
          }}
        />

        </section>

        
</>
                
              )
            
 
    


}


export default Articles;